class modalDetailCtrl {
    constructor($scope, $uibModalInstance, items1, httpRequest) {
        const waitDetailId = items1.waitId

        $scope.init = function (waitId) {
            httpRequest.get_getInvoiceDetailById(waitId).then((res) => {
                $scope.dataList = res.data.value
                if ($scope.dataList.length) {
                    $scope.isTaxText = $scope.dataList[0].isTax == '1' ? '含税' : '不含税'
                }
            })
        }
        $scope.init(waitDetailId)

        $scope.cancel = () => {
            $uibModalInstance.close()
        }
        $scope.ok = () => {
            $uibModalInstance.close()
        }
    }
}

modalDetailCtrl.$inject = ['$scope', '$uibModalInstance', 'items1', 'httpRequest']
export default modalDetailCtrl



// WEBPACK FOOTER //
// ./src/app/outputManage/fillOpenManage/eleInvoice/modalDetailCtrl.js